var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2487",
    "data-name": "Grupo 2487"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1548",
    "data-name": "Caminho 1548",
    d: "M18.909,1.091A3.7,3.7,0,0,0,16.276,0H3.724A3.724,3.724,0,0,0,0,3.724V16.276A3.728,3.728,0,0,0,3.724,20H16.276A3.728,3.728,0,0,0,20,16.276V3.724A3.7,3.7,0,0,0,18.909,1.091ZM6.479,7.044,9.586,3.937a.586.586,0,0,1,.829,0l3.107,3.106a.586.586,0,1,1-.829.829L10.586,5.766v6.251a.586.586,0,1,1-1.172,0V5.766L7.308,7.873a.586.586,0,1,1-.829-.829Zm9.169,9.191H4.352a.586.586,0,1,1,0-1.172h11.3a.586.586,0,1,1,0,1.172Z",
    fill: "#272f4c"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload-file.360247eef06ca3cc05c0b4aa2a29594f.svg";
export { ForwardRef as ReactComponent };